<!-- Mobile: parent link + current title only -->
<div class="breadcrumb-trail mobile-trail" data-testid="breadcrumb-bar-mobile">
  @for (item of mobileBreadcrumbs; track $index; let i = $index; let last = $last) {
  @if (last) {
  <span class="breadcrumb-item breadcrumb-current" aria-current="page">{{ item.label }}</span>
  } @else {
  <a class="breadcrumb-item breadcrumb-link" [routerLink]="item.url"><span class="back-chevron"
      aria-hidden="true">‹</span>{{ item.label }}</a>
  <span class="breadcrumb-separator" aria-hidden="true">›</span>
  }
  }
</div>

<!-- Full breadcrumb trail (desktop) -->
<div class="breadcrumb-trail merged-trail" data-testid="breadcrumb-bar">
  @for (item of visibleBreadcrumbs; track $index; let i = $index; let last = $last) {
  @if (last) {
  <span class="breadcrumb-item breadcrumb-current" [attr.data-testid]="'breadcrumb-item-' + i" aria-current="page">{{
    item.label }}</span>
  } @else {
  <a class="breadcrumb-item breadcrumb-link" [attr.data-testid]="'breadcrumb-item-' + i" [routerLink]="item.url">{{
    item.label }}</a>
  <span class="breadcrumb-separator" aria-hidden="true">›</span>
  }
  }
</div>